import {signal} from "@preact/signals-react";
import {IPaymentSuccessData} from "@/app/dashboard/models/PaymentSuccess";
import {getPaymentSuccessData} from "@/services/payment-service";
import {showCommonApiError} from "@/lib/toast-utill";


export const paymentSuccessData = signal<IPaymentSuccessData>()


export const loadPaymentSuccessData = async (paymentIntent: string, paymentRecordId: string) => {
    const [data, error] = await getPaymentSuccessData(paymentIntent, paymentRecordId);
    if (error) {
        return showCommonApiError("loading payment data")
    }

    paymentSuccessData.value = data;
}